import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Store from '../../Store';
import ModuleAttachToTile, { Props } from '../_components/ModuleAttachToTile'
import { OnAttachModule } from '../../Document/_actions/DocumentActions';

const mapStateToProps = (store:Store, props:Props) => ({
	active: store.hasIn(['create', 'document', 'attachedModule']) && store.getIn(['create', 'document', 'attachedModule']) == props.moduleId,
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onClick: (active: boolean) => dispatch(OnAttachModule(active ? null : props.moduleId)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleAttachToTile);